(() => {
  'use strict';
  const dialog = document.getElementById('LumaiaCartDrawer');

  if (!dialog || typeof dialog.showModal !== 'function') return;
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const content = $('[data-cart-drawer-content]', dialog);
  const panel = $('.lumaia-cart-panel', dialog);
  const rootURL = document.body.dataset.root || '/';
  const cartURL = new URL(rootURL + 'cart', location.origin);
  
  // Lumaïa — Fermer le panneau et rejoindre Tableaux
  document.addEventListener('click', event => {
    const link = event.target.closest(
      '.cart-empty-state a[href*="#tableaux"]'
    );

    if (!link || !dialog.contains(link)) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const destination = new URL(link.href);

    // Fermer le panneau
    dialog.close();
    document.body.classList.remove('cart-drawer-open');

    
    // Naviguer réellement vers la page d'accueil
    if (
      destination.origin !== location.origin ||
      destination.pathname.replace(/\/$/, '') !==
        location.pathname.replace(/\/$/, '')
    ) {
      window.location.assign(destination.href);
    } else {
      // Déjà sur l'accueil : rejoindre directement Tableaux
      window.location.hash = destination.hash;

      document.getElementById('tableaux')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, true);

  for (const [key, value] of new URL(location.href).searchParams) {
    if (key.startsWith('preview_')) cartURL.searchParams.set(key, value);
  }
  let sectionId = $('[data-cart-section]')?.dataset.sectionId;
  let busy = false;
  let reading = null;

  function message(root, text, error = false) {
    let node = $('[data-cart-status]', root);
    if (!node) {
      node = document.createElement('p');
      node.className = 'form-note';
      node.dataset.cartStatus = '';
      root.append(node);
    }
    node.setAttribute('role', error ? 'alert' : 'status');
    node.hidden = false;
    node.textContent = text;
  }

  function parseCart(html) {
    const section = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
    if (!section) throw new Error('Le panier ne peut pas être affiché pour le moment.');
    sectionId = section.dataset.sectionId;
    return section;
  }

  async function readCart() {
    reading?.abort();
    const controller = new AbortController();
    reading = controller;
    const response = await fetch(cartURL.href, {
      credentials: 'same-origin', cache: 'no-store', signal: controller.signal
    });
    if (!response.ok) throw new Error('Le panier ne peut pas être chargé pour le moment.');
    return parseCart(await response.text());
  }

  function copyState(from, to) {
    const oldNote = $('[name="note"]', from);
    const newNote = $('[name="note"]', to);
    if (oldNote && newNote) newNote.value = oldNote.value;
    const oldChoices = $$('[data-bundle-option]', from);
    const newChoices = $$('[data-bundle-option]', to);
    newChoices.forEach((select, index) => {
      const value = oldChoices[index]?.value;
      if (value && [...select.options].some(option => option.value === value)) select.value = value;
    });
    if (newChoices.length) updateBundle(newChoices[0]);
  }

  function renderCart(section) {
    const page = $$('[data-cart-section]').find(node => !dialog.contains(node));
    if (page) {
      const replacement = section.cloneNode(true);
      copyState(page, replacement);
      page.replaceWith(replacement);
    }
    const drawer = section.cloneNode(true);
    copyState(content, drawer);
    // The page and drawer can coexist: every drawer ID stays unique.
    const ids = new Map();
    $$('[id]', drawer).forEach(node => {
      const oldId = node.id;
      node.id = 'Drawer-' + oldId;
      ids.set(oldId, node.id);
    });
    $$('[for]', drawer).forEach(label => {
      const id = ids.get(label.htmlFor);
      if (id) label.htmlFor = id;
    });
    $$('[form]', drawer).forEach(node => {
      const id = ids.get(node.getAttribute('form'));
      if (id) node.setAttribute('form', id);
    });
    $('#LumaiaCartTitle').textContent = $('h1', section)?.textContent || 'Ton panier';
    content.replaceChildren(drawer);
    const count = Number(section.dataset.cartCount);
    $$('.cart-count').forEach(node => { node.textContent = count; });
    $$('.cart-toggle').forEach(link => {
      const label = link.getAttribute('aria-label');
      if (label) link.setAttribute('aria-label', label.replace(/\(\d+\)$/, `(${count})`));
    });
  }

  function showDrawer(opener) {
  if (dialog.open) return;

  if (location.pathname.replace(/\/$/, '') !== cartURL.pathname.replace(/\/$/, '')) {
    sessionStorage.setItem(
      'lumaiaCartOrigin',
      location.pathname + location.search + location.hash
    );
  }

  dialog.show();
  document.body.classList.add('cart-drawer-open');
    const icon = opener?.getBoundingClientRect() || $('.cart-toggle')?.getBoundingClientRect();
    const frame = panel.getBoundingClientRect();
    const closeFrame = panel.getBoundingClientRect();
    const menu = $('[data-menu-toggle]');

if (menu) {
  const box = menu.getBoundingClientRect();
  const bar = $('span:nth-child(2)', menu)?.getBoundingClientRect();
  const center = bar || box;

  panel.style.setProperty('--cart-close-x', `${center.left + center.width / 2 - closeFrame.left - 4}px`);
  panel.style.setProperty('--cart-close-y', `${center.top + center.height / 2 - closeFrame.top}px`);
  panel.style.setProperty('--cart-close-width', `${box.width}px`);
  panel.style.setProperty('--cart-close-height', `${box.height}px`);
  panel.style.setProperty('--cart-close-line', `${bar?.width || 25}px`);
}
    if (icon) {
      panel.style.setProperty('--cart-origin-x', `${icon.left + icon.width / 2 - frame.left}px`);
      panel.style.setProperty('--cart-origin-y', `${icon.top + icon.height / 2 - frame.top}px`);
    }
  }

  function loadingError(error) {
    content.replaceChildren();
    const p = document.createElement('p');
    p.className = 'lumaia-cart-load';
    p.setAttribute('role', 'alert');
    p.textContent = error.message;
    const link = document.createElement('a');
    link.className = 'text-link';
    link.href = cartURL.href;
    link.textContent = 'Ouvrir la page panier';
    content.append(p, link);
  }

  async function openCart(opener) {
    showDrawer(opener);
    if (busy) return;
    if (!$('[data-cart-section]', content)) {
      const p = document.createElement('p');
      p.className = 'lumaia-cart-load';
      p.textContent = 'Ton panier s’ouvre…';
      content.replaceChildren(p);
    }
    try { renderCart(await readCart()); }
    catch (error) { if (error.name !== 'AbortError') loadingError(error); }
  }

  async function mutate(action, data, scope, openAfter = false) {
    if (busy) return;
    busy = true;
    reading?.abort();
    const controls = $$('[data-cart-section] button, [data-cart-section] input, [data-cart-section] select, [data-cart-section] textarea, [data-product-section] form button, [data-product-section] form input')
      .map(node => [node, node.disabled]);
    const focused = document.activeElement;
    const focusId = focused?.id;
    const step = focused?.dataset.quantityStep;
    const quantityId = scope.matches?.('input') ? scope.id : null;
    const source = scope.closest('[data-cart-section]') || scope;
    const sourceInDrawer = dialog.contains(source);
    const form = scope.closest('form');
    controls.forEach(([node]) => { node.disabled = true; });
    form?.setAttribute('aria-busy', 'true');
    message(source, action === 'add' ? 'Ajout au panier…' : 'Mise à jour du panier…');
    if (sectionId) {
      data.set('sections', sectionId);
      data.set('sections_url', cartURL.pathname + cartURL.search);
    }
    let confirmed = false;
    try {
      const response = await fetch(rootURL + `cart/${action}.js`, {
        method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: data
      });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Cette modification n’est pas disponible.');
      confirmed = true;
      const html = result.sections?.[sectionId];
      const section = html ? parseCart(html) : await readCart();
      renderCart(section);
      if (source.matches('form')) message(source, '');
      if (openAfter) showDrawer($('.cart-toggle'));
      const target = (sourceInDrawer || openAfter)
        ? $('[data-cart-section]', content)
        : $$('[data-cart-section]').find(node => !dialog.contains(node));
      const note = action === 'add' ? 'Ajouté à ton panier.' : 'Panier mis à jour.';
      if (target) message(target, note);
      const live = $('[data-live-region]');
      if (live) live.textContent = note;
      if (!openAfter && target) {
        const id = quantityId || focusId;
        const input = $$('[id]', target).find(node => node.id === id);
        const focus = step && input
          ? $(`[data-quantity-step="${step}"]`, input.closest('.quantity-control'))
          : input;
        focus?.focus({ preventScroll: true });
      }
    } catch (error) {
      if (confirmed) { location.assign(cartURL.href); return; }
      if (scope.matches?.('input')) scope.value = scope.defaultValue;
      message(source, `${error.message || 'Mise à jour impossible.'} Si la connexion a été interrompue, vérifie ton panier avant de réessayer.`, true);
    } finally {
      busy = false;
      form?.removeAttribute('aria-busy');
      controls.forEach(([node, disabled]) => { node.disabled = disabled; });
    }
  }

  function changeQuantity(input, quantity) {
    const data = new FormData();
    data.set('id', input.dataset.cartKey);
    data.set('quantity', String(quantity));
    return mutate('change', data, input);
  }

  document.addEventListener('click', event => {
    const minus = event.target.closest('[data-cart-section] [data-quantity-step="-1"]');
    if (!minus) return;

    const input = minus.closest('.quantity-control')?.querySelector('input[data-cart-key]');
    if (!input || Number(input.value) !== 1) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!busy) changeQuantity(input, 0);
  }, true);

    function updateBundle(select) {
    const offer = select?.closest('.cart-duo');
    if (!offer) return null;

    const form = $('form[data-duo-form]', offer);
    const options = $$('[data-bundle-option]', form)
      .map(node => node.options[node.selectedIndex]);

    options.forEach((option, index) => {
      const frame = $(`[data-duo-image="${index}"]`, form);
      const image = $('img', frame);
      const hasImage = Boolean(option?.value && option.dataset.image);

      image.hidden = !hasImage;
      $('span', frame).hidden = hasImage;

      if (hasImage) {
        image.src = option.dataset.image;
        image.alt = option.dataset.title;
      } else {
        image.removeAttribute('src');
        image.alt = '';
      }
    });

    const complete = options.length === 2 &&
      options.every(option => option?.value && !option.disabled);

    const original = complete
      ? options.reduce((sum, option) => sum + Number(option.dataset.price), 0)
      : 0;

    const price = Number(options[0]?.dataset.duoPrice);

    const valid = Boolean(
      complete && original > 0 && price > 0 &&
      options[0].dataset.rumiId &&
      price === Math.round(original * .9)
    );

    const format = new Intl.NumberFormat(form.dataset.locale || 'fr', {
      style: 'currency',
      currency: form.dataset.currency || 'EUR'
    });

    $('[data-bundle-price]', form).textContent =
      valid ? format.format(price / 100) : '—';

    const compare = $('[data-bundle-compare]', form);
    compare.textContent = valid ? format.format(original / 100) : '';
    compare.hidden = !valid;

    $('[data-duo-badge]', form).hidden = Boolean(complete && !valid);

    const status = $('[data-duo-status]', form);
    status.hidden = !complete || valid;
    status.textContent = complete && !valid
      ? 'Cette combinaison n’est pas disponible dans l’offre Duo pour le moment.'
      : '';

    $('button[name="add"]', form).disabled = !valid;

    return valid
      ? { options, price, bundleId: options[0].dataset.rumiId }
      : null;
  }

  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const cart = event.target.closest('a.cart-toggle');
    if (cart) {
  event.preventDefault();
  
  if (document.body.classList.contains('template-cart')) {
    const origin = sessionStorage.getItem('lumaiaCartOrigin') || rootURL;
    sessionStorage.removeItem('lumaiaCheckoutReturn');
    window.location.assign(origin);
    return;
  }

  if (dialog.open) {
    dialog.close();
  } else {
    const menu = document.getElementById('LumaiaMenu');
    const toggle = document.querySelector('[data-menu-toggle]');

    if (menu && !menu.hidden) {
      menu.hidden = true;
      document.body.classList.remove('menu-open');
      toggle?.setAttribute('aria-expanded', 'false');
    }

    openCart(cart);
  }

  return;
}
    
const productLink = event.target.closest(
  '.cart-line:not(.cart-line--duo) > a[href], .cart-line:not(.cart-line--duo) h2 a[href]'
);

if (productLink && productLink.closest('[data-cart-section]')) {
  const destination = new URL(productLink.href, location.href);

  if (destination.origin === location.origin) {
    sessionStorage.setItem('lumaiaProductReturn', JSON.stringify({
      productPath: destination.pathname,
      returnUrl: location.pathname + location.search + location.hash,
      reopenPanel: dialog.contains(productLink)
    }));
  }
}
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      const input = $('input[data-cart-key]', remove.closest('.cart-line'));
      if (input) { event.preventDefault(); if (!busy) changeQuantity(input, 0); }
    }
  });

  document.addEventListener('change', event => {
    const input = event.target;
    if (input.matches('[data-bundle-option]')) { updateBundle(input); return; }
    if (!input.matches('[data-cart-section] input[name="updates[]"]') || busy) return;
    if (!input.checkValidity()) { input.reportValidity(); return; }
    const quantity = Number(input.value);
    if (Number.isInteger(quantity) && quantity > 0 && quantity !== Number(input.defaultValue)) changeQuantity(input, quantity);
  });

  document.addEventListener('submit', event => {
    const form = event.target;
    if (event.defaultPrevented) return;
    if (
  event.submitter?.name === 'checkout' &&
  form.closest('[data-cart-section]')
) {
  sessionStorage.setItem('lumaiaCheckoutReturn', '1');
  return;
}
    const bundle = form.matches('[data-bundle-form]');
    const product = form.closest('[data-product-section]') && event.submitter?.name === 'add';
    if (busy && (form.closest('[data-cart-section]') || product)) { event.preventDefault(); return; }
    if (!bundle && !product) return;
    event.preventDefault();
    if (!form.reportValidity()) return;
    const data = new FormData(form);

    if (bundle) {
      const duo = updateBundle($('[data-bundle-option]', form));
      if (!duo) return;

      const token = crypto.randomUUID();

      const properties = {
        _Bundle: 'Le Duo Lumaïa',
        _rumi_byob_bundle_id: duo.bundleId,
        _rumi_byob_token: token,
        _rumi_kit_price: String(duo.price),
        _rumi_incl: duo.options
          .map(option => option.dataset.title)
          .join(', '),
        _rumi_incl_label: 'Inclus',
        'Précommande': 'Expédition à partir du 7 décembre 2026'
      };

      duo.options.forEach((option, index) => {
        Object.entries(properties).forEach(([key, value]) => {
          data.set(`items[${index}][properties][${key}]`, value);
        });
      });
    }

    mutate('add', data, form, true);
  });

  // Le header suit le défilement du panneau sur tous les écrans.
const cartScroller = $('.lumaia-cart-inner', dialog);
const siteHeader = document.querySelector('.lumaia-header-section .header');

function syncCartHeaderScroll() {
  if (!siteHeader || !cartScroller) return;

  siteHeader.style.translate = dialog.open
    ? `0 ${-cartScroller.scrollTop}px`
    : '';
}

cartScroller?.addEventListener('scroll', syncCartHeaderScroll, {
  passive: true
});

  const headerMenuToggle = document.querySelector('[data-menu-toggle]');

function syncHeaderMenuToggle() {
  if (!headerMenuToggle) return;

  const productPage = Boolean(
    document.querySelector('[data-product-section]')
  );

  const menuOpen = document.body.classList.contains('menu-open');

  headerMenuToggle.setAttribute(
    'aria-expanded',
    String(dialog.open || menuOpen || productPage)
  );
}

$('[data-cart-close]', dialog).addEventListener('click', () => dialog.close());

dialog.addEventListener('click', event => {
  if (event.target === dialog) dialog.close();
});

dialog.addEventListener('close', () => {
  document.body.classList.remove('cart-drawer-open');
  syncCartHeaderScroll();
  syncHeaderMenuToggle();
});

dialog.addEventListener('toggle', syncHeaderMenuToggle);
})();
